<script>
  import { onMount } from 'svelte';
  import { isFirstLoad } from './stores.js';
  import { priceRange } from './constants.js';
  import ItemChooser from './components/ItemChooser.svelte';
  import ItemAllTable from './components/ItemAllTable.svelte';

  /**
   * props
   */
  let items; // テーブルを表示するためのデータ
  let allItems; // データを取得した初期値を保存
  let filterFlags = {
    kind: null,
    type: null,
    target_age: null,
    price: null,
    hardware: null,
    apptype: null,
    all: 'all' // 全アイテム表示のとき'all'、フィルターされているときはnull
  };

  /**
   * onMount
   */
  const reqURL = '/wp-json/kp/v2/itemall';
  onMount(async () => {
    await fetch(reqURL)
    .then(res => res.json())
    .then(json => {
      allItems = json;
      items = allItems; // itemsの初期値をallItemsにセット
      isFirstLoad.set(false);
    });
  });

  /**
   * filterItems
   * itemsを変更
   * 
   * @param e event
   */
  function handleFilterItems(e) {
    console.log('filterItems called');
    let tmpItems = allItems;
    // フィルタがかかっている項目だけ選ぶ
    const flags = Object.entries(filterFlags).filter(([key, value]) => value !== null);
    
    for(const [key, value] of flags) {
      // key=all 全アイテム表示
      if(key === 'all' && value === 'all') {
        items = allItems;
        console.log('all', items.length, items);
        break;
      }

      // key=kind ツール種類でフィルタ
      if(key === 'kind') {
        tmpItems = tmpItems.filter(item => item.tax_kind_slug === value);
        console.log(`kind: ${value}`, tmpItems.length, tmpItems);
      }
      // key=type 目的でフィルタ
      if(key === 'type') {
        tmpItems = tmpItems.filter(item => item.programming_type === value);
        console.log(`type: ${value}`, tmpItems.length, tmpItems);
      }
      // key=target_age 対象年齢でフィルタ
      if(key === 'target_age') {
        tmpItems = tmpItems.filter(item => item.target_age === value);
        console.log(`type: ${value}`, tmpItems.length, tmpItems);
      }
      // key=price 価格でフィルタ
      if(key === 'price') {
        const {min, max} = priceRange[value];
        tmpItems = tmpItems.filter(item => Number(item.price) >= min && Number(item.price) <= max);
        console.log(`price: ${value}`, tmpItems.length, tmpItems);
      }
      // key=hardware 使用機器でフィルタ
      if(key === 'hardware') {
        tmpItems = tmpItems.filter(item => item.hardware.find(subItem => subItem === value));
        console.log(`${key}, ${value}`, tmpItems.length, tmpItems);
      }
      // key=apptype 動作環境でフィルタ
      if(key === 'apptype') {
        tmpItems = tmpItems.filter(item => item.apptype.find(subItem => subItem === value));
        console.log(`${key}, ${value}`, tmpItems.length, tmpItems);
      }
      items = tmpItems;
    }
  }
</script>

<section class="item-all-table">
  <ItemChooser
    items={items}
    filterFlags={filterFlags}
    on:filterChanged={handleFilterItems}
  />
  <ItemAllTable items={items}/>
</section>

<style>

</style>